/** 安卓外壳的原生能力（ADR-0012，android/.../ShellPlugin.java）。在浏览器里打开时这些都不可用。 */
import { Capacitor, registerPlugin } from "@capacitor/core";

export type ShellInfo = { versionCode: number; versionName: string; mac: string | null };

interface ZhaoxiShell {
  info(): Promise<ShellInfo>;
  check(options: { url: string }): Promise<{ ok: boolean; status: number; message: string }>;
  open(options: { url: string }): Promise<void>;
  reset(): Promise<void>;
  installUpdate(options: { url: string }): Promise<{ started?: boolean; needsPermission?: boolean }>;
  fullscreen(options: { on: boolean; color?: string }): Promise<void>;
}

export const shell = registerPlugin<ZhaoxiShell>("ZhaoxiShell");

/** 是否在朝夕安卓版里（而不是浏览器）。 */
export const inApp = (): boolean => Capacitor.isNativePlatform();

/**
 * 阅读时全屏：藏起状态栏（从屏幕顶上往下滑会临时出现），离开阅读页时记得 setFullscreen(false)。
 * color 是上下系统栏那两条的底色（"#RRGGBB"，跟阅读背景一致）。浏览器里、或手机上的安装包还没有这个能力时什么也不做。
 */
export function setFullscreen(on: boolean, color?: string): void {
  if (inApp()) shell.fullscreen({ on, color }).catch(() => {});
}

export type LatestApk = { versionCode: number; versionName: string; size: number };

export async function latestApk(): Promise<LatestApk | null> {
  try {
    const res = await fetch("/downloads/version.json", { cache: "no-store" });
    return res.ok ? ((await res.json()) as LatestApk) : null;
  } catch {
    return null;
  }
}
